import React from 'react';
import SEO from '../common/SEO';
import ColorSwitcher from '../elements/switcher/ColorSwitcher';
import FooterOne from '../common/footer/FooterOne';
import CtaLayoutOne from '../component/cta/CtaLayoutOne';
import ProjectOne from '../component/project/ProjectOne';
import ServicePropOne from '../component/service/ServicePropOne';
import SectionTitle from '../elements/section-title/SectionTitle';
import BannerFive from '../component/banner/BannerFive';
import HeaderFour from '../common/header/HeaderFour';
import { useTranslation } from 'react-i18next';

const PaginaInicial = () => {
    const { t } = useTranslation();
    return (
        <>
        <SEO title="Main Page"/>
        <ColorSwitcher />
        <main className="main-wrapper">
        <HeaderFour />
        <BannerFive />

        <div className="section section-padding">
            <div className="container">
            <SectionTitle 
                //subtitle="O que podemos fazer por si"
                title={t('Service pour les quelles<br> nous pouvont vous aider')}
                description=""
                textAlignment="heading-left mb--20 mb_md--70"
                textColor=""
            />
                <div className="row">
                    <ServicePropOne colSize="col-lg-4" serviceStyle="service-style-2" marginTop="yes"/>
                </div>
            </div>
            <ul className="shape-group-7 list-unstyled">
                <li className="shape shape-1"><img src={process.env.PUBLIC_URL + "/images/others/circle-2.webp"} alt="circle" /></li>
                <li className="shape shape-2"><img src={process.env.PUBLIC_URL + "/images/others/bubble-2.webp"} alt="Line" /></li>
                <li className="shape shape-3"><img src={process.env.PUBLIC_URL + "/images/others/bubble-1.webp"} alt="Line" /></li>
            </ul>

        </div>
        <ProjectOne parentClass="bg-color-light" />
        {/* <TestimonialOne /> */}
        {/* <BrandOne /> */}
        <CtaLayoutOne />
        <FooterOne />
        </main>
        </>
    )
}

export default PaginaInicial;